var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"el",class:[
    'idtr-editable',
    { 'idtr-editable--inline': _vm.inline, 'idtr-editable--error': _vm.error },
  ],attrs:{"id":_vm.id || null,"data-placeholder":_vm.placeholder || null,"contenteditable":"true","spellcheck":"false"},on:{"input":_vm.onInput,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.onEnter.apply(null, arguments)},"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }